export default __webpack_public_path__ + "static/media/exit-orange-thick.2d938856.svg";